import React from "react";
import { UNIT_SPLIT_RE } from "../lib/caseSafe";

export const CaseSafe = ({ text }) => {
  if (typeof text !== "string") return text ?? null;
  return text.split(UNIT_SPLIT_RE).map((part, i) =>
    i % 2 ? (
      <span key={i} className="normal-case">
        {part}
      </span>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
};
